import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PackingListPDF from "../utils/PackingListpdf";
import ReusableDataTable from "../hooks/ReusableDataTable";
import { Button, Modal } from "flowbite-react";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { useSidebar } from "../context/SidebarOpenContext";
import { AuthContext } from "../context/AuthContext";
import { IoMdDownload } from "react-icons/io";
import { FaBoxOpen } from "react-icons/fa";
function Order() {
    const navigate = useNavigate();
    const [Order, Setorder] = useState([]);
    const [Input, setInput] = useState();
    const { user } = useContext(AuthContext);
    const [DeleteModal, setDeleteModal] = useState(false);
    const { isSidebarOpen } = useSidebar();
    const [packingData, setPackingData] = useState(null);
    const role = sessionStorage.getItem('role');
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            fetchorder();
        }
    }, [user, navigate]);

    const fetchorder = async () => {
        try {
            const response = await axios.get("order/orders");
            Setorder(response.data);
        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };

    const fetchPackingList = async (order_id) => {
        try {
            const response = await axios.get(`/boxing/boxing/${order_id}`);
            setPackingData(response.data);
        } catch (error) {
            console.error("Error fetching packing list:", error);
        }
    };

    const deletOrder = async () => {
        try {
            axios.delete(`order/orders/${Input}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Order deleted",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchorder();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
            });
        } catch (error) {
            console.error("Error deleting order:", error);
        }
    };

    const data = Array.isArray(Order)
        ? Order.map((order) => ({
            id: order.order_id,
            orderdate: new Date(order.order_date).toLocaleDateString('en-GB'),
            buyername: order.buyer_name,
            cutorderno: order.cut_order_no,
            jobno: order.job_no,
            option: (
                <div style={{ display: "flex" }}>
                
                    <FaEye className="text-sky-600 text-2xl" onClick={() => navigate(`/view_order_details?id=${order.order_id}`)} />
                    {/* <PDFDownloadLink document={<PackingListPDF data={packingData} />} fileName={`PackingList_${order.order_id}.pdf`}>
                        {({ loading }) => loading ? "Loading..." : <IoMdDownload className="ml-2 text-sky-600 text-2xl" onClick={() => fetchPackingList(order.order_id)} />}
                    </PDFDownloadLink> */}
                    <FaBoxOpen className="ml-2 text-yellow-700 text-xl" onClick={() => navigate(`/boxing?id=${order.order_id}`)}  />
                    {(role === 'super_admin' ) &&
                    <>
                    <FaPen className="ml-2 text-amber-400 text-xl" onClick={() => navigate(`/edit_order?id=${order.order_id}`)} />
                    <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput(order.order_id) }} />
                    </>
                    }
                    </div>
            )
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Order Date", selector: (row) => row.orderdate, sortable: true },
        { name: "Buyer Name", selector: (row) => row.buyername, sortable: true },
        { name: "Order No", selector: (row) => row.cutorderno, sortable: true },
        { name: "PO No", selector: (row) => row.jobno, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen" : "p-4 bg-content-bg min-h-screen"}`}> 
            <div className="p-4 rounded-lg dark:border-gray-700 mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                {( role === 'super_admin') &&

                    <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" onClick={() => navigate("/addorder")}>
                        Add Order
                    </Button> }

                    <ReusableDataTable title="Order List" columns={columns} data={data} />
                    <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                        <Modal.Header />
                        <Modal.Body>
                            <div className="text-center">
                                <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                    Are you sure you want to delete this order?
                                </h3>
                                <div className="flex justify-center gap-4">
                                    <Button color="failure" onClick={() => deletOrder()}>Yes</Button>
                                    <Button className="ml-2" color="gray" onClick={() => setDeleteModal(false)}>No</Button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default Order;
